import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { Pagination } from '@sd-portal/shared/models';

@Component({
  selector: 'sd-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {
  totalPages: number;
  startPage: number = 1;
  endPage: number = 10;
  pages: number[];
  maxPageNumbers: number = 5;

  @Input() model: Pagination;
  @Input() showFirstLastActions: boolean = true;
  @Input() showPreviousNextActions: boolean = true;
  @Input() dataSubscription: BehaviorSubject<Pagination>;
  /*only for airport map side nav*/
  @Input() isMapSideNav = false;
  @Output() paginationEvent = new EventEmitter();

  constructor() {}

  /* life-cycle */
  ngOnInit() {
    if (this.dataSubscription) {
      this.dataSubscription.subscribe(pagination => {
        this.model = {
          ...pagination,
          pageSizeOptions: pagination.pageSizeOptions || new Pagination().pageSizeOptions
        };
        this.buildPager();
      });
    }
  }

  /* publics */
  setPage(pg: number) {
    this.model.pageNumber = pg;
    this.updatePagination();
  }

  setPageSize(size: number) {
    this.model.pageSize = size;
    this.updatePagination();
  }

  private buildPageList() {
    this.totalPages = Math.ceil(this.model.totalCount / this.model.pageSize);
    this.startPage = 1;

    //prevent bypassing max page
    if (this.model.pageNumber > this.totalPages) {
      this.model.pageNumber = this.totalPages > 0 ? this.totalPages : 1;
    }

    if (this.totalPages <= this.maxPageNumbers) {
      this.endPage = this.totalPages;
    } else {
      if (this.model.pageNumber + 2 >= this.totalPages) {
        this.startPage = this.totalPages - 4;
        this.endPage = this.totalPages;
      } else {
        const minStartPage = this.model.pageNumber - 2;
        this.startPage = minStartPage < 1 ? 1 : minStartPage;
        this.endPage = minStartPage < 1 ? this.maxPageNumbers : this.model.pageNumber + 2;
      }
    }
  }

  private setPageArray() {
    this.pages = [];
    for (let i = this.startPage; i <= this.endPage; i++) {
      this.pages.push(i);
    }
  }

  private buildPager() {
    this.buildPageList();
    this.setPageArray();
  }

  private updatePagination() {
    this.buildPager();
    this.paginationEvent.emit(this.model);
  }
}
